
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { AdminLayout } from '../../components/feature/AdminLayout';

export default function AdminDashboard() {
  const [stats] = useState({
    totalCertificates: 1247,
    activeCertificates: 1198,
    expiredCertificates: 49,
    monthlyRevenue: 2450000,
    thisMonthIssued: 156,
    pendingPayments: 8
  });

  const [recentCertificates] = useState([
    {
      id: 'CERT-2024-156',
      studentName: '김학습',
      courseName: '디지털 마케팅 전문가 과정',
      issueDate: '2024-01-20',
      status: 'active',
      isPaid: true,
      downloadCount: 2
    },
    {
      id: 'CERT-2024-155',
      studentName: '이수료',
      courseName: 'AI 활용 비즈니스 전략',
      issueDate: '2024-01-19',
      status: 'active',
      isPaid: false,
      downloadCount: 0
    },
    {
      id: 'CERT-2024-154',
      studentName: '박완료',
      courseName: '데이터 분석 실무',
      issueDate: '2024-01-18',
      status: 'active',
      isPaid: true,
      downloadCount: 1
    },
    {
      id: 'CERT-2024-153',
      studentName: '최교육',
      courseName: '프로젝트 관리 전문가',
      issueDate: '2024-01-17',
      status: 'expired',
      isPaid: true,
      downloadCount: 3
    },
    {
      id: 'CERT-2024-152',
      studentName: '정학습',
      courseName: '클라우드 컴퓨팅 기초',
      issueDate: '2024-01-16',
      status: 'active',
      isPaid: false,
      downloadCount: 0
    }
  ]);

  return (
    <AdminLayout>
      <div className="p-6">
        {/* 페이지 헤더 */}
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">대시보드</h1>
          <p className="text-sm text-gray-500 mt-1">한국디지털교육원 관리자 대시보드</p>
        </div>

        {/* 통계 카드 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                <i className="ri-file-text-line text-xl text-blue-600"></i>
              </div>
              <div className="ml-4">
                <p className="text-sm text-gray-500">총 발급 증명서</p>
                <p className="text-2xl font-bold text-gray-900">{stats.totalCertificates.toLocaleString()}</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                <i className="ri-check-line text-xl text-green-600"></i>
              </div>
              <div className="ml-4">
                <p className="text-sm text-gray-500">활성 증명서</p>
                <p className="text-2xl font-bold text-gray-900">{stats.activeCertificates.toLocaleString()}</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                <i className="ri-time-line text-xl text-orange-600"></i>
              </div>
              <div className="ml-4">
                <p className="text-sm text-gray-500">이번 달 발급</p>
                <p className="text-2xl font-bold text-gray-900">{stats.thisMonthIssued}</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                <i className="ri-money-dollar-circle-line text-xl text-blue-600"></i>
              </div>
              <div className="ml-4">
                <p className="text-sm text-gray-500">이번 달 수익</p>
                <p className="text-2xl font-bold text-gray-900">₩{stats.monthlyRevenue.toLocaleString()}</p>
              </div>
            </div>
          </div>
        </div>

        {/* 빠른 액션 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-upload-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">증명서 발급</h3>
              <p className="text-gray-600 mb-4">엑셀 파일을 업로드하여 여러 증명서를 한번에 발급하세요.</p>
              <Link to="/admin/bulk-issue">
                <button className="w-full bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-upload-line mr-2"></i>
                  파일 업로드
                </button>
              </Link>
            </div>
          </div>

          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-template-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">템플릿 관리</h3>
              <p className="text-gray-600 mb-4">증명서 템플릿을 생성하고 수정하세요.</p>
              <Link to="/admin/templates">
                <button className="w-full border border-blue-600 text-blue-600 px-4 py-2 rounded-lg hover:bg-blue-50 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-template-line mr-2"></i>
                  템플릿 설정
                </button>
              </Link>
            </div>
          </div>

          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-group-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">학습자 관리</h3>
              <p className="text-gray-600 mb-4">등록된 학습자 정보를 조회하고 관리하세요.</p>
              <Link to="/admin/students">
                <button className="w-full border border-blue-600 text-blue-600 px-4 py-2 rounded-lg hover:bg-blue-50 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-group-line mr-2"></i>
                  학습자 목록
                </button>
              </Link>
            </div>
          </div>
        </div>

        {/* 최근 발급 증명서 */}
        <div className="bg-white rounded-lg border border-gray-200">
          <div className="flex justify-between items-center p-6 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-900">최근 발급 증명서</h2>
            <Link to="/admin/certificates">
              <button className="border border-blue-600 text-blue-600 px-3 py-1.5 text-sm rounded-lg hover:bg-blue-50 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-eye-line mr-1"></i>
                전체 보기
              </button>
            </Link>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-200 bg-gray-50">
                  <th className="text-left py-3 px-6 font-medium text-gray-600 text-sm">증명서 ID</th>
                  <th className="text-left py-3 px-6 font-medium text-gray-600 text-sm">학습자명</th>
                  <th className="text-left py-3 px-6 font-medium text-gray-600 text-sm">과정명</th>
                  <th className="text-left py-3 px-6 font-medium text-gray-600 text-sm">발급일</th>
                  <th className="text-left py-3 px-6 font-medium text-gray-600 text-sm">상태</th>
                  <th className="text-left py-3 px-6 font-medium text-gray-600 text-sm">다운로드</th>
                  <th className="text-left py-3 px-6 font-medium text-gray-600 text-sm">액션</th>
                </tr>
              </thead>
              <tbody>
                {recentCertificates.map((cert) => (
                  <tr key={cert.id} className="border-b border-gray-100 hover:bg-gray-50">
                    <td className="py-4 px-6 font-mono text-sm text-blue-600">{cert.id}</td>
                    <td className="py-4 px-6 font-medium text-gray-900">{cert.studentName}</td>
                    <td className="py-4 px-6 text-gray-700">{cert.courseName}</td>
                    <td className="py-4 px-6 text-gray-600">{cert.issueDate}</td>
                    <td className="py-4 px-6">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                        cert.status === 'active' 
                          ? 'bg-green-100 text-green-800' 
                          : 'bg-red-100 text-red-800'
                      }`}>
                        {cert.status === 'active' ? '활성' : '만료'}
                      </span>
                    </td>
                    <td className="py-4 px-6">
                      <div className="flex items-center space-x-2">
                        <span className="text-sm text-gray-600">{cert.downloadCount}회</span>
                        {cert.isPaid && (
                          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                            유료
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="flex space-x-2">
                        <button className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-blue-600 transition-colors cursor-pointer">
                          <i className="ri-eye-line"></i>
                        </button>
                        <button className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-green-600 transition-colors cursor-pointer">
                          <i className="ri-download-line"></i>
                        </button>
                        <button className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-red-600 transition-colors cursor-pointer">
                          <i className="ri-pause-circle-line"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
